import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy',
  standalone: true,
})
export class SortByPipe implements PipeTransform {
  transform<T>(array: T[], key: keyof T, order: 'asc' | 'desc' = 'asc'): T[] {
    if (!array || !key) {
      return array;
    }

    // Create a copy to prevent mutation of the original array
    const sorted = [...array];

    return sorted.sort((a, b) => {
      const valA: unknown = a[key];
      const valB: unknown = b[key];

      // Handle cases where values are missing
      if (valA === undefined || valA === null) {
        return 1;
      }

      if (valB === undefined || valB === null) {
        return -1;
      }

      // Handle numeric sorting
      if (typeof valA === 'number' && typeof valB === 'number') {
        return order === 'asc'
          ? valA - valB
          : valB - valA;
      }

      // Handle string sorting (case-insensitive)
      const strA: string = valA.toString().toLowerCase();
      const strB: string = valB.toString().toLowerCase();

      if (strA < strB) {
        return order === 'asc'
          ? -1
          : 1;
      }

      if (strA > strB) {
        return order === 'asc'
          ? 1
          : -1;
      }

      return 0;
    });
  }
}
